<template>
  <div class="menu-page">
    <div v-if="currentUser.account.max_channels == 1">
      <v-alert class="fade" dense text type="warning">
        Funcionalidade indisponível neste plano. Por favor, faça upgrade para o plano Profissional ou superior.
        <ib-btn class="ml-2" color="warning" @click.native="$router.push('/minha-conta')">
          Ver planos disponíveis
        </ib-btn>
      </v-alert>
    </div>

    <v-alert v-if="currentUser.account.max_channels > 1 && currentUser.account.api_key === undefined" class="fade pb-4" dense text type="error">
      Chave de API não gerada. Por favor, gere uma chave de API.
      <div>
        <ib-btn class="mt-2" color="error" @click.native="$router.push('/api')">
          Gerar chave de API
        </ib-btn>
      </div>
    </v-alert>

    <v-alert v-if="showAlert" class="fade pb-4" dense text type="error" dismissible>
      Sua conta não possui nenhum número conectado. Será necessário conectar um número/chip para fazer o envio.
      <div>
        <ib-btn class="mt-2" color="error" @click.native="$router.push('/chips')">
          Conectar número
        </ib-btn>
      </div>
    </v-alert>

    <v-card v-if="currentUser.account.max_channels > 1 && currentUser.account.api_key !== undefined" class="mb-4 nd-border" flat>
      <v-card-title>
        Webhooks
      </v-card-title>

      <v-card-subtitle>
        Configure e mapeie dados de webhooks para acionar um chatbot de fluxo (conexão direta) ou template (API Oficial) com eventos de outros sistemas. <ib-btn small @click="showVideo = true"><v-icon size="16" class="mr-1">mdi-help-circle-outline</v-icon>Saiba mais</ib-btn>
      </v-card-subtitle>

      <v-card-text>
        <v-row class="d-flex justify-space-between">
          <v-col cols="12" sm="6" md="4">
            <ib-text-field v-model="search" placeholder="Busque pelo nome do webhook" append-icon="mdi-magnify" outlined hide-details="auto" clearable />
          </v-col>
          <v-col cols="12" sm="6" md="4" class="d-flex align-center justify-end">
            <ib-btn color="primary" @click.native="dialogCreate = true">
              <v-icon left>mdi-plus</v-icon>
              Novo Webhook
            </ib-btn>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-data-table :headers="headers" :items="filteredObjects" :loading="loading">
              <template #[`item.flow.name`]="{ item }">
                {{ (item.flow && item.flow.name) ? item.flow.name : '-' }}
              </template>

              <template #[`item.template.name`]="{ item }">
                {{ (item.template && item.template.name) ? item.template.name : '-' }}
              </template>

              <template #[`item.status`]="{ item }">
                <ib-chip :tonal="!$isDark" small :color="statusMap[item.status]?.color || '#999'">
                  {{ statusMap[item.status]?.label || item.status }}
                </ib-chip>
              </template>

              <template #[`item.actions`]="{ item }">
                <v-menu class="d-flex">
                  <template #activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon>mdi-dots-horizontal</v-icon>
                    </v-btn>
                  </template>

                  <v-card>
                    <v-list-item :to="`/webhooks/${item._id}`">
                      <v-list-item-icon>
                        <v-icon>mdi-file-edit-outline</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>Editar</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="duplicateWebhook(item)">
                      <v-list-item-icon>
                        <v-icon>mdi-content-copy</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>Duplicar</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>

                    <v-list-item @click="deleteWebhook(item)">
                      <v-list-item-icon>
                        <v-icon>mdi-trash-can-outline</v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title>Apagar</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-card>
                </v-menu>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <ib-dialog v-model="dialogCreate" scrollable max-width="550" persistent>
      <v-card>
        <ib-dialog-header title="Novo webhook" :close="() => { dialogCreate = false }"></ib-dialog-header>

        <v-card-text>
          <v-row>
            <v-col cols="12">
              <ib-text-field class="mt-2" v-model="selectedObject.name" label="Nome" outlined hide-details="auto" />
            </v-col>

            <v-col cols="12">
              <ib-autocomplete v-model="selectedObject.chip" return-object outlined :items="chips" item-text="name" no-data-text="Não há números conectados" item-value="_id" label="Selecione um chip de envio" hide-details="auto" />
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <ib-btn color="gray200" outlined @click="dialogCreate = false">
            <div class="gray1000--text">
              Cancelar
            </div>
          </ib-btn>
          <v-spacer />
          <ib-btn color="primary" :loading="loading" @click="createWebook()">
            Criar
          </ib-btn>
        </v-card-actions>
      </v-card>
    </ib-dialog>
    <video-dialog v-model="showVideo" videoUrl="https://www.youtube.com/embed/M-KS0VoNxkw?si=2_BbZeU2dlEW3CZq" />
  </div>
</template>

<script>
import Api from "@/lib/Api";

export default {
  name: "WebhookList",

  data() {
    return {
      showAlert: false,
      showVideo: false,
      loading: false,
      objects: [],
      filteredObjects: [],
      search: '',
      selectedObject: {},
      chips: [],
      validChips: [],
      flows: [],
      dialogCreate: false,
      headers: [
        { text: 'Nome', value: 'name', sortable: false },
        { text: 'Chip', value: 'chip.name', sortable: false },
        { text: 'Fluxo', value: 'flow.name', sortable: false },
        { text: 'Template', value: 'template.name', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Ações', value: 'actions', sortable: false, width: 100 },
      ],
      statusMap: {
        active:   { label: 'Ativo', color: '#0B9055' },
        inactive: { label: 'Inativo', color: '#9E9E9E' },
        test:  { label: 'Teste', color: '#1976D2' }
      },  
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
  },

  watch: {
    search() {
      this.filterObjects();
    }
  },

  async mounted() {
    if (!this.currentUser?.access_areas?.includes('api')) {
      this.$toast("error", "Permissões insuficientes.");
      this.$router.replace({ name: 'Atendimento' });
    }

    this.load();
  },

  methods: {
    filterObjects() {
      if (!this.search || this.search.trim() === '') {
        this.filteredObjects = this.objects;
      } else {
        const searchLower = this.search.toLowerCase();
        this.filteredObjects = this.objects.filter(webhook =>
          webhook.name.toLowerCase().includes(searchLower)
        );
      }
    },

    async load() {
      this.loading = true;

      const webhooks = await Api.getWebhooksByUser();
      if (!webhooks.error && webhooks.message) {
        this.objects = webhooks.message;
        this.filterObjects();
      }

      const chips = await Api.getChipNumbersByUser();
      if (!chips.error && chips.message) {
        this.chips = chips.message;
        this.validChips = [];
        let hasConnection = false;

        chips.message.forEach(chip => {
          if (chip.status == 'open') {
            this.validChips.push(chip.name);
            hasConnection = true;
          }
        });

        if (!hasConnection) this.showAlert = true;
      }

      const flows = await Api.getFlowsByUser();
      if (!flows.error && flows.message) {
        this.flows = flows.message;
      }

      this.loading = false;
    },

    async createWebook() {            
      this.loading = true;
      const resp = await Api.createOrUpdateWebhook(this.selectedObject);
      this.loading = false;

      if (resp.error && resp.message) return      

      this.selectedObject = {};
      this.dialogCreate = false;
      this.$toast("success", "Webhook criado!");
      setTimeout(() => {
        this.$router.push(`/webhooks/${resp.message.upsertedId}`)
      }, 500);
    },

    async duplicateWebhook(item) {
      const confirmDuplicate = await this.$store.dispatch('confirmDialog', {
        title: "Duplicar Webhook",
        message: `Deseja duplicar o webhook ${item.name}?`
      });

      if (!confirmDuplicate) return

      this.loading = true;

      const { _id, ...webhookCopy } = item;
      delete webhookCopy.created;
      webhookCopy.name = `${item.name} - Cópia`;

      const resp = await Api.createOrUpdateWebhook(webhookCopy);
      this.loading = false;

      if (resp.error && resp.message) return

      this.$toast("success", "Webhook duplicado com sucesso!");
      setTimeout(() => {
        this.$router.push(`/webhooks/${resp.message.upsertedId}`);
      }, 500);
    },

    async deleteWebhook(item) {
      const confirmDelete = await this.$store.dispatch('confirmDialog', {
        title: "Apagar Webhook",
        message: `Deseja realmente apagar o webhook ${item.name}?`
      });

      if (!confirmDelete) return

      const response = await this.$api.createOrUpdateWebhook({
        ...item,
        filed: true
      });

      if (response.error) return

      this.$toast("success", "Webhook apagado com sucesso");

      await this.load();
    },
  },
};
</script>

<style scoped></style>
